import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import { useHistory } from "react-router-dom";
//Material
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
//Component
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
import BootstrapTable from 'react-bootstrap-table-next';
//Function
import { getViewColumns } from "./columns/job-schedule";
import { GetUser } from "../../utils/sessions";
import * as alertDialog from "../../utils/alert";
import AddJobSchedule from "./add-job"
import EditJobSchedule from "./edit-job"
import ViewHistory from "./view-history"
import * as api from "./api";
import { useSelectItem } from "../../stories/react-table/useSelectItem";
import Button from '@material-ui/core/Button';
import { isEmptyArray } from "../../utils/common-function";
import { useSignalR } from "./../function-api/useSignalR";
import { url, method } from "./signalr";

const rowStyle = (row, rowIndex) => {
  return { backgroundColor: row.STATUS_COLOR };
};

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 400,
  },
  rootButton: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 150,
  },
  searchText: {
    textAlign: '-webkit-right'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
  },
  iconButtonAddDelete: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
  buttonGrid: {
    // textAlign: "right",
    // align: "right",
  },
  textBullet: {
    fontSize: 21
  },
  textNotice: {
    fontSize: 15
  },
}));
function JobSchedule() {
  const classes = useStyles();
  //State
  const methodForm = useForm();
  const history = useHistory();
  const { register, getValues } = methodForm;
  const [DataList, setDataList] = useState([]);
  const [DataNotice, setDataNotice] = useState([]);
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalViewHistory, setOpenModalViewHistory] = useState(false);
  const [JobGUID, setJobGUID] = useState();
  const { handleOnSelect, handleOnSelectAll, SelectedItems } = useSelectItem(
    "JOB_GUID"
  );
  //Effect
  useEffect(() => {
    fetch();
    fetchNoti();

  }, []);
  const fetchNoti = async () => {
    let res = await api.GetListNotice();
    setDataNotice(res);
  }
  
  const signalRHandler =  useCallback(async (data) => {
    fetch();
  }, []);

  useSignalR(url, method, signalRHandler);

  const fetch = async () => {
    let param = { "TEXT_SEARCH": getValues()?.TEXT_SEARCH ,"USER_ID": GetUser(),"MODE":"Refresh" };
    let res = await api.GetListJobSchedule(param);
    setDataList(res);
  }
  const SearchText = async () => {
    console.log(getValues().TEXT_SEARCH);
    setDataList([]);
    let param = { "TEXT_SEARCH": getValues()?.TEXT_SEARCH ,"USER_ID": GetUser(),"MODE":"Refresh" };
    //console.log(param);
    let res = await api.GetListJobSchedule(param);
    setDataList(res);
    handleOnSelectAll(false);

  }


  const onDelete = async () => {
    if (isEmptyArray(SelectedItems)) {
      alertDialog.ErrorDialog("Please Select Item.");
      return;
    }
    //console.log(SelectedItems);
    let resConfirm = await alertDialog.ConfirmCommon("Do you want to delete item ?", "Yes", "No");
    if (!resConfirm) return;

    let param = { JOB_GUID: SelectedItems };
    let res = await api.DeleteJobSchedule(param);
    if (res?.ResultCode === 10) {
      alertDialog.Success();
      setDataList([]);
      fetch();
      handleOnSelectAll(false);
      handleOnSelect([]);
    }
    else {
      alertDialog.ErrorDialog("Error : " + res.Message);
    }

  }

  const onOpenAddModal = () => {
    history.push("/DecryptScreen");
  }

  const onCloseViewModalAdd = async () => {
    setOpenModalAdd(false);
    let res = await api.ClearConnectDB();
    //window.location.reload();
  };
  const onCloseViewModalEdit = () => {
    setOpenModalEdit(false);

  };
  const onCloseViewModalHistory = () => {
    setOpenModalViewHistory(false);
  };

  const onAddJob = async () => {
    let res = await api.CheckQuataAddJobByUser();
    if (res?.ResultCode === 10) {
      if (res?.Message === 'ADD') {
        setJobGUID(JobGUID);
        setOpenModalAdd(true);
      }
      else {
        alertDialog.ErrorDialog("ไม่สามารถ Add ได้เนื่องจากไม่มี Quota / Quota เต็ม.");
      }

    }
    else {
      alertDialog.ErrorDialog("Error : " + res.Message);
    }

  }
  const onEditJob = (JobGUID) => {
    setJobGUID(JobGUID);
    setOpenModalEdit(true);
  }

  const onViewHistory = (JobGUID) => {
    setJobGUID(JobGUID);
    setOpenModalViewHistory(true);
  }

  // const onDownloadFile = async (pathFile) => {

  //   //console.log(pathFile);
  //   if (pathFile !== null)
  //     window.open(`${API_URL.Loader}/Export/` + pathFile, '_blank');
  //     //window.open(`${API_URL.Loader}/Export/webexport/schedule/` + pathFile, '_blank');
  //   else
  //     alertDialog.ErrorDialog("Error : File Not Found");
  // }
  const onDownloadFile = async (pID) => {
    let param = { "EXEC_NO": pID };
    let res = await api.DownloadFile(param);
    //console.log(res);
    if(res?.FileName){
      window.open( `${API_URL.Loader}/Export/`+res?.FileName, '_blank');
    }
    else
    {
      alertDialog.ErrorDialog("Error : File Not Found");
    }
  }

  const handleEnter = (e) => {
    if (e.keyCode === 13) {
      SearchText();
      e.preventDefault();
    }
  }


  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Job Schedule" >
          <FormProvider {...method}>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={8} container spacing={1}>
                <Grid item xs={4} className={classes.buttonGrid}>

                  <Button variant="contained" className={classes.iconButtonAddDelete} onClick={onAddJob}>
                    Add
                  </Button>
                  <Button variant="contained" className={classes.iconButtonAddDelete} onClick={onDelete}>
                    Delete
                  </Button>
                </Grid>

              </Grid>
              <Grid item xs={4} className={classes.searchText}>
                <Paper component="form" className={classes.rootSearch}>

                  <InputBase
                    className={classes.input}
                    placeholder="Search"
                    inputProps={{ 'aria-label': 'search' }}
                    name="TEXT_SEARCH"
                    inputRef={register}
                    onKeyDown={(e) => handleEnter(e)}
                  />
                  {/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
              <SearchIcon />
            </IconButton> */}
                  <Divider className={classes.divider} orientation="vertical" />
                  <Button variant="contained" className={classes.iconButton} onClick={SearchText}>
                    Search
                  </Button>

                </Paper>

              </Grid>
            </Grid>

            {DataList?.length > 0 ?
              (<ReactTable id="1"
                keyField="JOB_GUID"
                data={DataList}
                clickToSelect
                rowStyle={rowStyle}
                showSearch={false}
                //headcomponent={tablecomponent}
                handleOnSelect={handleOnSelect}
                handleOnSelectAll={handleOnSelectAll}
                columns={getViewColumns(onDownloadFile, onEditJob, onViewHistory,true)}
              />) : <BootstrapTable keyField='JOB_GUID' data={[]} columns={getViewColumns(onDownloadFile, onEditJob, onViewHistory,false)} noDataIndication={'No results found'} />}
          </FormProvider>

          <Grid item xs={4} container spacing={1}>
            <Grid item xs={12} >
              <br />
              <div style={{ color: DataNotice?.COLOR_YELLOW }}>
                <span className={classes.textBullet}>██</span> <span className={classes.textNotice}>{DataNotice?.TEXT_YELLOW}</span>
              </div>
              <div style={{ color: DataNotice?.COLOR_RED }}>
                <span className={classes.textBullet}>██</span> <span className={classes.textNotice}>{DataNotice?.TEXT_RED}</span>
              </div>
              <div style={{ color: DataNotice?.COLOR_GREY }}>
                <span className={classes.textBullet}>██</span> <span className={classes.textNotice}>{DataNotice?.TEXT_GREY}</span>
              </div>
            </Grid>
          </Grid>
        </BoxTemplate1>
        <AddJobSchedule
          open={openModalAdd}
          onClose={onCloseViewModalAdd}
        />
        <EditJobSchedule
          open={openModalEdit}
          onClose={onCloseViewModalEdit}
          JobGUID={JobGUID}
        />
        <ViewHistory
          open={openModalViewHistory}
          onClose={onCloseViewModalHistory}
          JobGUID={JobGUID}
        />
      </BaseContainer>
    </div>
  );
}
export default JobSchedule;
